module.exports = __webpack_public_path__ + "img/IMG_1297.db84e2bd.jpeg";